import { PaperConfig } from './types';

/**
 * English Language Paper 2 (1EN0/02)
 * - Section A: Reading (two non-fiction texts) - Q1-Q7
 * - Section B: Transactional Writing - Q8/Q9 (choice of two)
 */
export const englishLanguagePaper2Config: PaperConfig = {
  paperCode: '1EN0/02',
  displayName: 'English Language Paper 2',
  subject: 'English Language',
  paperNumber: 'Paper 2',
  totalTimeMinutes: 120, // 2 hours

  sections: [
    {
      id: 'A',
      title: 'SECTION A',
      subtitle: 'Reading',
      instructions: [
        'Read Text 1 and Text 2 in the Reading Text Insert provided and answer ALL questions.',
        'You should spend about 1 hour 20 minutes on this section.',
        'Write your answers in the spaces provided.',
      ],
      categories: ['Q1', 'Q2', 'Q3', 'Q4', 'Q5', 'Q6', 'Q7A', 'Q7B'],
      timeGuidance: 80,
    },
    {
      id: 'B',
      title: 'SECTION B',
      subtitle: 'Transactional Writing',
      instructions: [
        'Answer ONE question. You should spend about 40 minutes on this section.',
        'Write your answer in the space provided.',
      ],
      categories: ['SectionB'],
      hasQuestionChoice: true,
      timeGuidance: 40,
    },
  ],

  readingInsert: {
    textCount: 2,
    buttonLabels: ['View Text 1', 'View Text 2'],
    // Q4, Q5, Q6 use Text 2 only
    text2Categories: ['Q4', 'Q5', 'Q6'],
    // Q7A and Q7B compare both texts — show both buttons
    dualViewCategories: ['Q7A', 'Q7B'],
    // Everything else (Q1, Q2, Q3) defaults to Text 1 only
  },
};
